require('dom-slider');

const { slideToggle } = window.domSlider;

const regionButtons = document.querySelectorAll(
	'.block-navigation-quick-links__nav-toggle-button'
);
const languageToggleButtons = document.querySelectorAll(
	'.block-navigation-quick-links__language-toggle'
);

const clickOffMenu = (e) => {
	if (e.key && e.key !== 'Escape') {
		return;
	}

	if (regionButtons.length > 0) {
		regionButtons.forEach((regionButton) => {
			if (regionButton.classList.contains('active')) {
				regionButton.click();
			}
		});
	}

	if (languageToggleButtons.length > 0) {
		languageToggleButtons.forEach((languageToggleButton) => {
			if (languageToggleButton.classList.contains('active')) {
				languageToggleButton.click();
			}
		});
	}

	document.removeEventListener('keydown', clickOffMenu);
	document.removeEventListener('click', clickOffMenu);
};

const toggle = (e) => {
	e.preventDefault();

	const quickLinksBlock = e.currentTarget.closest(
		'.block-navigation-quick-links'
	);

	if (quickLinksBlock) {
		const openToggles = quickLinksBlock.querySelectorAll(
			'.block-navigation-quick-links__nav-toggle-button.active'
		);

		if (openToggles.length > 0) {
			openToggles.forEach((openToggle) => {
				if (openToggle !== e.currentTarget) {
					openToggle.click();
				}
			});
		}
	}

	if (
		!e.currentTarget.classList.contains(
			'block-navigation-quick-links__nav-toggle-button--opening'
		)
	) {
		e.currentTarget.classList.toggle('active');
		e.currentTarget.classList.add(
			'block-navigation-quick-links__nav-toggle-button--opening'
		);

		const currentContent = e.currentTarget.parentElement.nextElementSibling;

		currentContent.classList.remove(
			'block-navigation-quick-links__nav-toggle--hidden'
		);

		slideToggle({
			element: currentContent,
			slideSpeed: 400,
			easing: 'ease-in-out',
		}).then((contentElement) => {
			if (contentElement.classList.contains('DOM-slider-hidden')) {
				contentElement.classList.add(
					'block-navigation-quick-links__nav-toggle--hidden'
				);
			} else {
				document.addEventListener('keydown', clickOffMenu);
				document.addEventListener('click', clickOffMenu);
			}

			const buttonElement =
				contentElement.previousElementSibling.children[0];

			if (buttonElement) {
				buttonElement.classList.remove(
					'block-navigation-quick-links__nav-toggle-button--opening'
				);
			}
		});
	}
};

if (regionButtons.length > 0) {
	regionButtons.forEach((regionButton) => {
		regionButton.addEventListener('click', toggle);
	});
}

if (languageToggleButtons.length > 0) {
	languageToggleButtons.forEach((languageToggleButton) => {
		languageToggleButton.addEventListener('click', (e) => {
			e.currentTarget.classList.toggle(
				'block-navigation-quick-links__language-toggle--selected'
			);
		});
	});
}
